'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (time) {
    var tokens = time.split(':');
    if (tokens.length < 2 || tokens.length > 3) {
        return false;
    }

    return tokens.map(function (val, ind) {
        switch (ind) {
            case 0:
                return parseInt(val, 0) < 24;
            case 1:
                return parseInt(val, 0) <= 59;
            default:
                return parseInt(val, 0) <= 59;
        }
    }).indexOf(false) === -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/isValidTime.js
// module id = 64
// module chunks = 0